import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Sem serviço externo de erros: o console é o único registro no cliente.
    console.error('ErrorBoundary:', error, errorInfo?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/inicio';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-6 text-center">
          <div className="w-16 h-16 bg-error/10 rounded-full flex items-center justify-center text-error mb-6">
            <span className="material-symbols-outlined text-3xl">error</span>
          </div>
          <h2 className="text-xl font-headline font-semibold text-on-surface mb-2">Algo deu errado nesta tela</h2>
          <p className="text-on-surface-variant max-w-md mx-auto mb-8 text-sm">
            Tivemos um problema inesperado ao carregar este conteúdo. Você pode tentar recarregar a página ou voltar para o início.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center w-full max-w-xs sm:max-w-md">
            <button
              onClick={this.handleReload}
              className="px-6 py-2.5 bg-primary text-on-primary font-medium rounded-full hover:bg-primary/90 transition-colors flex items-center justify-center gap-2 flex-1"
            >
              <span className="material-symbols-outlined text-sm">refresh</span>
              Recarregar
            </button>
            <button
              onClick={this.handleGoHome}
              className="px-6 py-2.5 border border-outline-variant text-on-surface font-medium rounded-full hover:bg-surface-container transition-colors flex items-center justify-center gap-2 flex-1"
            >
              <span className="material-symbols-outlined text-sm">home</span>
              Voltar ao início
            </button>
          </div>

        </div>
      );
    }

    return this.props.children;
  }
}
